import { Col, Row } from "antd";
import React from "react";

const data = [
  {
    id: 1,
    heading: "Hours",
    desc: "Monday-Friday:",
    para: "9:00 am - 6:00 pm EST",
    icon: "/assets/clock.svg",
  },
  {
    id: 2,
    heading: "Contact Us",
    desc: "Phone: +1-866-696-7539",
    para: "  Email: info@metaworldx.com",
    icon: "/assets/contact_phone.svg",
  },
  {
    id: 3,
    heading: "Our Address",
    desc: "Toronto,",
    para: " ON Canada",
    icon: "/assets/location_mark.svg",
  },
];

function ContactDetails() {
  return (
    <Row className="mb-[60px]">
      {data.map((item) => {
        return (
          <Col key={item.id} xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
            <div className="flex items-center justify-center flex-col max-[991px]:my-[20px]">
              <div className="w-[75px] !h-[75px] max-[575px]:!w-[42px] ">
                <img src={item.icon} width="100%" height="100%" alt="" />
              </div>
              <div className="font-semibold text-[30px] text-[white] max-[575px]:text-[20px]">
                {item.heading}
              </div>
              <div className="font-normal text-[22px] text-[white] max-[575px]:text-[18px]">
                {item.desc}
              </div>
              <div className="font-normal text-[22px] text-[white] max-[575px]:text-[18px]">
                {item.para}
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default ContactDetails;
